export { default as PostCheckbox } from './component';
